import ReportsView from './views/ReportsView.vue'
import ReportViewPeople from './components/ReportViewPeople'
import ReportViewPresentation from './components/ReportViewPresentation'
import ReportViewConsulta from './components/ReportViewConsulta'
import ReportViewExpediente from './components/ReportViewExpediente'
import ReportViewContratoJugadores from './components/ReportViewContratoJugadores'
import ReportViewContratoCuerpoTecnico from './components/ReportViewContratoCuerpoTecnico'
import ReportViewCondicionJugadores from './components/ReportViewCondicionJugadores'
import ReportViewCondicionCuerpoTecnico from './components/ReportViewCondicionCuerpoTecnico'
import ReportViewTransferencias from './components/ReportViewTransferencias'
import ReportViewPagosJugadores from './components/ReportViewPagosJugadores'
import ReportViewPagosCuerpoTecnico from './components/ReportViewPagosCuerpoTecnico'
import ReportViewVencimientoContratoJugadores from './components/ReportViewVencimientoContratoJugadores'
import ReportViewVencimientoContratoCuerpoTecnico from './components/ReportViewVencimientoContratoCuerpoTecnico'
import ReportViewAdendasJugadores from './components/ReportViewAdendasJugadores'
import ReportViewAdendasCuerpoTecnico from './components/ReportViewAdendasCuerpoTecnico'
import ReportViewInformesPartidos from './components/ReportViewInformesPartidos'
import ReportViewDetailContratoJugadores from './components/ReportViewDetailContratoJugadores'
import ReportViewDetailContratoCuerpoTecnico from './components/ReportViewDetailContratoCuerpoTecnico'

export default [
  {
    path: '/reportes',
    name: 'reportes',
    component: ReportsView,
    children: [
      {
        path: 'people',
        name: 'reporte-people',
        component: ReportViewPeople
      },
      {
        path: 'presentaciones',
        name: 'reporte-presentaciones',
        component: ReportViewPresentation
      },
      {
        path: 'consultas',
        name: 'reporte-consultas',
        component: ReportViewConsulta
      },
      {
        path: 'expedientes',
        name: 'reporte-expedientes',
        component: ReportViewExpediente
      },
      {
        path: 'contratos/jugadores',
        name: 'reporte-contratos-jugadores',
        component: ReportViewContratoJugadores
      },
      {
        path: 'contratos/cuerpo-tecnico',
        name: 'reporte-contratos-cuerpo-tecnico',
        component: ReportViewContratoCuerpoTecnico
      },
      {
        path: 'contratos/detalle/jugadores',
        name: 'reporte-contratos-detalle-jugadores',
        component: ReportViewDetailContratoJugadores
      },
      {
        path: 'contratos/detalle/cuerpo-tecnico',
        name: 'reporte-contratos-detalle-cuerpo-tecnico',
        component: ReportViewDetailContratoCuerpoTecnico
      },
      {
        path: 'condiciones/jugadores',
        name: 'reporte-condiciones-jugadores',
        component: ReportViewCondicionJugadores
      },
      {
        path: 'condiciones/cuerpo-tecnico',
        name: 'reporte-condiciones-cuerpo-tecnico',
        component: ReportViewCondicionCuerpoTecnico
      },
      {
        path: 'pagos/jugadores',
        name: 'reporte-pagos-jugadores',
        component: ReportViewPagosJugadores
      },
      {
        path: 'pagos/cuerpo-tecnico',
        name: 'reporte-pagos-cuerpo-tecnico',
        component: ReportViewPagosCuerpoTecnico
      },
      {
        path: 'transferencias',
        name: 'reporte-transferencias',
        component: ReportViewTransferencias
      },
      {
        path: 'contratos/vencimientos/jugadores',
        name: 'reporte-vencimientos-contratos-jugadores',
        component: ReportViewVencimientoContratoJugadores
      },
      {
        path: 'contratos/vencimientos/cuerpo-tecnico',
        name: 'reporte-vencimientos-contratos-cuerpo-tecnico',
        component: ReportViewVencimientoContratoCuerpoTecnico
      },
      {
        path: 'adendas/jugadores',
        name: 'reporte-adendas-jugadores',
        component: ReportViewAdendasJugadores
      },
      {
        path: 'adendas/cuerpo-tecnico',
        name: 'reporte-adendas-cuerpo-tecnico',
        component: ReportViewAdendasCuerpoTecnico
      },
      {
        path: 'informes/partidos',
        name: 'reporte-informes-partidos',
        component: ReportViewInformesPartidos
      }
    ]
  }
]
